export const MANUAL_CALENDAR_SLUGS = ['pikupoikka', 'isopoikka', 'mestari'];

export function hasManualCalendar(slug: string) {
  return MANUAL_CALENDAR_SLUGS.includes(slug);
}
